import { render, staticRenderFns } from "./VideoBlock.vue?vue&type=template&id=cec76702&"
import script from "./VideoBlock.vue?vue&type=script&lang=js&"
export * from "./VideoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports